import {
    FETCH_CART_LIST_REQUEST,
    FETCH_CART_LIST_SUCCESS,
    FETCH_CART_LIST_FAILURE,
} from "../types";

const initialState = {
    profile: null,
    isloading: false,
    error: null,
    status: "idle",
};

const cartReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CART_LIST_REQUEST:
            return { ...state, isloading: true, error: null, status: "pending" };
        case FETCH_CART_LIST_SUCCESS:
            return { ...state, isloading: false, status: "success", cartlist: action.payload.cartlist, shippingAmount: action.payload.Shipping_amount, };
        case FETCH_CART_LIST_FAILURE:
            return { ...state, isloading: false, status: "failed", cartlist: [], error: action.payload };
        default:
            return state;
    }
};

export default cartReducer;
